import { z } from "zod";
import { adminOperationsExtendedSchemaVersionSchema, adminReasonCodeSchema, adminSafeIdentifierSchema, } from "./admin-operations-core.js";
import { adminUlidSchema } from "./admin-operations-core.js";
export const adminEvidenceServiceSchema = z.enum([
    "ADMIN_API",
    "CUSTOMER_API",
    "WORKFLOW",
    "COMMERCE",
    "DELIVERY",
    "AUDIT_ARCHIVE",
]);
export const adminEvidenceSearchCommandSchema = z
    .object({
    caseId: adminUlidSchema.optional(),
    selector: z.discriminatedUnion("kind", [
        z.object({ kind: z.literal("CORRELATION_ID"), value: z.string().uuid() }).strict(),
        z.object({ kind: z.literal("REQUEST_ID"), value: adminSafeIdentifierSchema }).strict(),
        z.object({ kind: z.literal("REASON_CODE"), value: adminReasonCodeSchema }).strict(),
    ]),
    services: z.array(adminEvidenceServiceSchema).min(1).max(6),
    from: z.string().datetime(),
    to: z.string().datetime(),
    limit: z.number().int().positive().max(100).default(50),
})
    .strict()
    .refine((command) => Date.parse(command.to) > Date.parse(command.from), {
    path: ["to"],
    message: "Evidence range must move forward.",
})
    .refine((command) => Date.parse(command.to) - Date.parse(command.from) <= 24 * 60 * 60 * 1_000, {
    path: ["to"],
    message: "Evidence searches are limited to 24 hours.",
});
export const adminEvidenceRecordSchema = z
    .object({
    occurredAt: z.string().datetime(),
    service: adminEvidenceServiceSchema,
    event: adminSafeIdentifierSchema,
    outcome: z.enum(["SUCCEEDED", "DENIED", "FAILED", "ATTENTION_REQUIRED", "OBSERVED"]),
    reasonCode: adminReasonCodeSchema,
    correlationId: z.string().uuid().optional(),
    requestId: adminSafeIdentifierSchema.optional(),
    subjectType: adminSafeIdentifierSchema.optional(),
    subjectId: adminSafeIdentifierSchema.optional(),
})
    .strict();
export const adminEvidenceSearchResponseSchema = z
    .object({
    data: z
        .object({
        schemaVersion: adminOperationsExtendedSchemaVersionSchema,
        records: z.array(adminEvidenceRecordSchema).max(100),
        truncated: z.boolean(),
    })
        .strict(),
})
    .strict();
//# sourceMappingURL=admin-operations-evidence.js.map